import { isEmpty } from '@/utils/basic';

export default {
  methods: {
    /**
     * 차트 클릭시 plotLine이 그려진다.
     * @param  {[type]} chart [description]
     * @param  {[type]} e     [description]
     * @return {[type]}       [description]
     * @author jda
     */
    onClickChart(chart, e) {
      if (isEmpty(chart.series[0])) {
        return;
      }

      const point = chart.series[0].searchPoint(e, true);
      const commonLineChats = this.$refs.commonLineChart;
      if (point) {
        commonLineChats.forEach((lineChart) => {
          lineChart.setPlotLine(point.x);
          lineChart.setCustomTooltip('plotLine');
        });
      }
    },
    /**
     * 차트에 마우스 오버 했을 시 crosshair을 모든 차트에서 공유한다.
     * @param  {[type]} point [description]
     * @return {[type]}       [description]
     * @author jda
     */
    onMouseOverChart(point, e) {
      const commonLineCharts = this.$refs.commonLineChart;
      if (isEmpty(commonLineCharts) || isEmpty(point)) {
        return;
      }

      commonLineCharts.forEach((cmp) => {
        const chart = cmp.$refs.highchart.chart;
        chart.xAxis[0].drawCrosshair(e, point);
        cmp.setCustomTooltip();
      });
    },
    /**
     * 차트에 focus가 되지 않았을 경우 그려진 crosshair을 지운다.
     * @return {[type]} [description]
     * @author jda
     */
    onMouseOutChart() {
      const commonLineCharts = this.$refs.commonLineChart;
      if (isEmpty(commonLineCharts)) {
        return;
      }

      commonLineCharts.forEach((cmp) => {
        const chart = cmp.$refs.highchart.chart;
        chart.xAxis[0].hideCrosshair();
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/chart/chart-analysis.js